module.exports = __webpack_public_path__ + "img/promo.c7e378c9.png";